let cachedVapidKey = null;

async function getVapidKey() {
  if (cachedVapidKey) return cachedVapidKey;

  const res = await fetch("/api/vapid");
  if (!res.ok) throw new Error("Failed to fetch VAPID key");
  const data = await res.json();
  cachedVapidKey = data.public_key;
  return cachedVapidKey;
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export async function subscribeUserToPush() {
  if (!("serviceWorker" in navigator)) {
    alert("Service workers are not supported in your browser.");
    return null;
  }

  if (!("PushManager" in window)) {
    alert("Push messaging is not supported in your browser.");
    return null;
  }

  try {
    // Register (or update) the service worker
    const registration = await navigator.serviceWorker.register("/svc.js");
    console.log("Service worker registered");

    // Wait for service worker to be ready and active
    await navigator.serviceWorker.ready;

    // Ensure we have an active service worker
    if (!registration.active) {
      console.log("Waiting for service worker to activate...");
      await new Promise((resolve) => {
        const checkState = () => {
          if (registration.active) {
            resolve();
          } else {
            setTimeout(checkState, 100);
          }
        };
        checkState();
      });
    }

    // Check for existing push subscription
    let subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      console.log("Found existing subscription");
      return subscription;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      alert("You must allow notifications to receive push messages.");
      return null;
    }

    // Subscribe to push notifications
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(await getVapidKey()),
    });

    console.log("New subscription created");
    return subscription;
  } catch (err) {
    console.error("Push subscription failed:", err);
    if (err.name === "AbortError") {
      alert(
        "Unable to subscribe/send: is your browser blocking push notifications?",
      );
    } else {
      alert("Failed to subscribe to push notifications: " + err.message);
    }
    return null;
  }
}
